export const TARGET_METRICS = ['NEW_MEMBERSHIPS', 'MEMBERSHIP_REVENUE', 'RENEWALS', 'PACKAGE_REVENUE', 'LEAD_CONVERSIONS'] as const;
export type TargetMetric = (typeof TARGET_METRICS)[number];

export type TargetMetricKind = 'count' | 'money';

export const TARGET_METRIC_KINDS: Record<TargetMetric, TargetMetricKind> = {
  NEW_MEMBERSHIPS: 'count',
  MEMBERSHIP_REVENUE: 'money',
  RENEWALS: 'count',
  PACKAGE_REVENUE: 'money',
  LEAD_CONVERSIONS: 'count',
};

/** A target belongs to the whole gym, to a branch or to a staff member, never to two of them. */
export const TARGET_SCOPES = ['GYM', 'BRANCH', 'STAFF'] as const;
export type TargetScope = (typeof TARGET_SCOPES)[number];

export const TARGET_MONTH_PATTERN = /^\d{4}-(0[1-9]|1[0-2])$/;
